module.exports = __webpack_public_path__ + "img/nutritious.7fac0150.svg";